"use client";

import { ExplorePersonRowV2 } from "components/ui/v2/explore/bundle/ExplorePersonRowV2";
import { useModal } from "context/modal/modal.provider";
import moment from "moment";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { IUser } from "types/User.types";

export interface CelebrationUserItemV2Props {
  user: IUser;
  birthdayCard?: boolean;
  anniversaryCard?: boolean;
  newUsersCard?: boolean;
  compact?: boolean;
}

/** Fila de persona en modal de celebraciones (variante A/B Explore). */
export function CelebrationUserItemV2({
  user,
  birthdayCard,
  anniversaryCard,
  newUsersCard,
  compact = false,
}: CelebrationUserItemV2Props) {
  const { t } = useTranslation("celebration");
  const { closeModal } = useModal();
  const router = useRouter();

  const validateBirthday = birthdayCard && user?.isBirthday;
  const validateAnniversary = anniversaryCard && user?.isAnniversary;
  const validateNewUsers = newUsersCard && user?.isNewUser;
  const canCongratulate =
    validateAnniversary || validateBirthday || validateNewUsers;

  const handleCongratulate = () => {
    if (!canCongratulate) return;
    if (validateBirthday) {
      closeModal();
      router.push(`/app/thread/${user?.birthdayMessageId}`);
    }
    if (validateAnniversary) {
      closeModal();
      router.push(`/app/thread/${user?.anniversaryMessageId}`);
    }
    if (validateNewUsers) {
      closeModal();
      router.push(`/app/thread/${user?.newUsersMessageId}`);
    }
  };

  const yearsWorking = moment().year() - moment(user.activeSince).year();
  const birthdayDate = user.birthday ?? user.birthDate;
  const dateLabel = birthdayCard
    ? moment(birthdayDate).format(`DD z[${t("de")}] MMMM`)
    : anniversaryCard
      ? `${moment(user.activeSince).format(`DD z[${t("de")}] MMM YYYY`)} ( ${yearsWorking} ${t(yearsWorking === 1 ? "año" : "años")} )`
      : newUsersCard && user.activeSince
        ? moment(user.activeSince).format(`DD z[${t("de")}] MMM YYYY`)
        : "";

  if (compact) {
    return (
      <div className="rounded-lg px-1 py-1.5">
        <ExplorePersonRowV2
          user={user}
          secondaryLine={[user.email, dateLabel].filter(Boolean).join(" · ")}
          onClick={canCongratulate ? handleCongratulate : undefined}
          className={
            canCongratulate
              ? "cursor-pointer hover:bg-slate-50/80 dark:hover:bg-zinc-800/40"
              : ""
          }
        />
      </div>
    );
  }

  return (
    <ExplorePersonRowV2
      user={user}
      secondaryLine={[user.email, dateLabel].filter(Boolean).join(" · ")}
      trailing={
        dateLabel && !user.email ? (
          <span className="whitespace-nowrap text-[9px] text-slate-500 dark:text-zinc-400">
            {dateLabel}
          </span>
        ) : null
      }
      onClick={canCongratulate ? handleCongratulate : undefined}
      className={
        canCongratulate
          ? "cursor-pointer hover:bg-slate-50/80 dark:hover:bg-zinc-800/40"
          : ""
      }
    />
  );
}
